import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-order-head-calcs',
  templateUrl: './order-head-calcs.component.html',
  styleUrls: ['./order-head-calcs.component.css']
})
export class OrderHeadCalcsComponent implements OnInit {
    orderInternalNo;

    public setting?: Setting;

    public itemsListCalculations: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.orderInternalNo = this.stateService.getStateParams()['order_internal_no'];
    }

    private async loadSetting() {
        if (!!this.orderInternalNo) {
            this.setting = (await this.datatask.Post(885, { order_internal_no: this.orderInternalNo }))[0];
        }
    }

    private async loadCalculations() {
        if (!this.setting) return;

        return this.itemsListCalculations = await this.datatask.Post(887, { order_internal_no: this.setting.order_internal_no });
    }

    private async init() {
        await this.loadSetting();
        this.loadCalculations();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    order_internal_no: string;
    ordertype_name: string;
    order_offer_no: string;
    order_order_no: string;
    stat_cust_name: string;
}
